import { ReactElement } from 'react'

import { Separator } from './styles'

interface AccountLabelProps {
  accountNumber: string | null
  name: string
}

export const AccountLabel = ({ accountNumber, name }: AccountLabelProps): ReactElement => {
  if (!accountNumber) {
    return <>{name}</>
  }

  return (
    <>
      {accountNumber}
      <Separator aria-hidden="true"> | </Separator>
      {name}
    </>
  )
}
